import { render } from "./ConfirmDeleteAccountModal.vue?vue&type=template&id=543e5202"
import script from "./ConfirmDeleteAccountModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteAccountModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/lie/repo/blisspot_vue_app/nuron-vuejs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__